import React from 'react';
import { useTheme } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import { LEGALMENTE_LOGO_SRC } from '../brandAssets';
import { legalmenteForegroundOnPage } from '../legalmenteReadableText';

const Values = () => {
  const theme = useTheme();
  const headingColor = legalmenteForegroundOnPage(theme);

  const values = [
    {
      title: 'Impacto en vivo',
      subtitle:
        'Transmisión todos los lunes a las 12:00 PM en la primera radio visual de Venezuela, con el respaldo de más de una década de innovación en TNO Network.',
      icon: (
        <svg width={24} height={24} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z"
          />
        </svg>
      ),
    },
    {
      title: 'La bóveda digital',
      subtitle:
        'Grabación y alojamiento en plataforma con una comunidad de más de 30.000 visitas al mes: tu pieza queda disponible para consulta recurrente.',
      icon: (
        <svg width={24} height={24} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M5 8h14M5 8a2 2 0 110-4h14a2 2 0 110 4M5 8v10a2 2 0 002 2h10a2 2 0 002-2V8m-9 4h4"
          />
        </svg>
      ),
    },
    {
      title: 'Vida perpetua del mensaje',
      subtitle:
        'Cada episodio es material educativo On-Demand: la marca no desaparece tras la emisión; permanece ligada al contenido que la audiencia vuelve a ver.',
      icon: (
        <svg width={24} height={24} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M14.752 11.168l-3.197-2.132A1 1 0 0010 9.87v4.263a1 1 0 001.555.832l3.197-2.132a1 1 0 000-1.664z M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
          />
        </svg>
      ),
    },
    {
      title: 'Entorno brand safe',
      subtitle:
        'Contenido institucional y familiar: alianzas pensadas para autoridad legal, alcance digital y prestigio de marca en un contexto seguro.',
      icon: (
        <svg width={24} height={24} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"
          />
        </svg>
      ),
    },
  ];

  return (
    <Box>
      <Box marginBottom={4}>
        <Typography
          sx={{ textTransform: 'uppercase', fontWeight: 'medium', color: headingColor }}
          gutterBottom
          align="center"
        >
          Ventajas competitivas
        </Typography>
        <Box
          component={Typography}
          sx={{
            fontWeight: 700,
            fontFamily: 'Georgia, "Times New Roman", serif',
            color: headingColor,
          }}
          variant="h3"
          gutterBottom
          align="center"
        >
          ¿Por qué Legalmente en Familia?
        </Box>
      </Box>
      <Grid container spacing={4}>
        <Grid item xs={12} md={6}>
          <Box
            maxWidth={500}
            width="100%"
            margin="0 auto"
            position="relative"
            sx={{
              border: `2px solid ${theme.palette.secondary.main}`,
              borderRadius: 2,
              p: 1,
              boxShadow: 2,
            }}
          >
            <Box
              sx={{
                width: '100%',
                minHeight: { xs: 240, sm: 280 },
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                py: 3,
                px: 2,
                bgcolor: theme.palette.primary.main,
                borderRadius: 1,
              }}
            >
              <Box
                component="img"
                src={LEGALMENTE_LOGO_SRC}
                alt="Legalmente en Familia — logo oficial"
                sx={{
                  width: '100%',
                  maxWidth: 320,
                  maxHeight: 280,
                  objectFit: 'contain',
                }}
              />
            </Box>
          </Box>
        </Grid>
        <Grid item xs={12} md={6}>
          {values.map((item, index) => (
            <Box
              key={index}
              display="flex"
              alignItems="flex-start"
              marginBottom={4}
              data-aos="fade-up"
              data-aos-delay={index * 100}
            >
              <Box
                sx={{
                  width: 50,
                  height: 50,
                  borderRadius: '50%',
                  bgcolor: `${theme.palette.primary.light}22`,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: headingColor,
                  marginRight: 2,
                  flexShrink: 0,
                }}
              >
                {item.icon}
              </Box>
              <Box>
                <Typography variant="h6" gutterBottom sx={{ fontWeight: 700 }}>
                  {item.title}
                </Typography>
                <Typography color="textSecondary">{item.subtitle}</Typography>
              </Box>
            </Box>
          ))}
        </Grid>
      </Grid>
    </Box>
  );
};

export default Values;
